@if (pager && pager.totalPages > 1) {
  <div class="pager layout-row align-center spacer-vr-16">
    <span class="txt-light-grey">Showing</span>
    <div class="seo-paginator-range-label">
      <!-- regular pagination range -->
      @if (pager.isFirst) {
        {{ pager.pageNumber * pager.pageSize + 1 }} - {{ lastArticleNumber }} of {{ pager.totalElements }}
      }
    </div>
  </div>
  <div class="pager layout-row align-center spacer-vr-16">
    <div class="seo-paginator small">
      <div class="seo-paginator-range-actions">
        <!-- "beginning" link (double chevron) -->
        <a class="pager-icon-button first" [class.isDisabled]="pager.isFirst" [attr.aria-disabled]="pager.isFirst" [href]="beginningLink">
          <span class="pager-button-wrapper">
            <svg viewBox="0 0 24 24" focusable="false" class="pager-icon">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
            </svg>
            <svg viewBox="0 0 24 24" focusable="false" class="pager-icon">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
            </svg>
          </span>
        </a>
        <!-- "previous" link (single chevron) -->
        <a class="pager-icon-button" [class.isDisabled]="pager.isFirst" [attr.aria-disabled]="pager.isFirst" [href]="prevLink">
          <span class="pager-button-wrapper">
            <svg viewBox="0 0 24 24" focusable="false" class="pager-icon">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
            </svg>
          </span>
        </a>
        <!-- page numbers -->
        @for (page of paginationPreview; track page; let i = $index; let first = $first) {
          <a [href]="getNumberLink(i)" class="pager-page-number" [class.active]="paginationPreview[i] === currentPage">
            <span class="pager-button-wrapper">{{ paginationPreview[i] }}</span>
          </a>
        }
        <!-- "next" link (single chevron) -->
        <a class="pager-icon-button" [class.isDisabled]="pager.isLast" [attr.aria-disabled]="pager.isLast" [href]="nextLink">
          <span class="pager-button-wrapper">
            <svg viewBox="0 0 24 24" focusable="false" class="pager-icon">
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
            </svg>
          </span>
        </a>
        <!-- "end" link (double chevron) -->
        <a class="pager-icon-button last" [class.isDisabled]="pager.isLast" [attr.aria-disabled]="pager.isLast" [href]="endLink">
          <span class="pager-button-wrapper">
            <svg viewBox="0 0 24 24" focusable="false" class="pager-icon">
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
            </svg>
            <svg viewBox="0 0 24 24" focusable="false" class="pager-icon">
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
            </svg>
          </span>
        </a>
      </div>
    </div>
  </div>
}
